import logger from '@core/util/universal-logger';

export default async function useServiceWorker() {
  let wb;

  try {
    ({ default: wb } = await import(/* webpackChunkName: "service-worker" */'../serviceWorker'));

    /* ['installed', 'waiting', 'controlling', 'activated'].forEach((eventName) => {
      wb.addEventListener(eventName, ({ isUpdate, isExternal }) => {
        console.info(`workbox: finished the "${eventName}" event`, { isUpdate, isExternal });
      });
    }); */

    wb.register();
  } catch (e) {
    logger.error('Error while registering the service worker', e);
  }

  /* return {
    async getVersion() {
      let version;

      if (wb) {
        version = await wb.messageSW({ type: 'GET_VERSION' });
      }
      return version;
    },

    async clearApiCache() {
      if (!wb) {
        logger.error('clearApiCache: service worker is not defined.');
        return false;
      }

      return await wb.messageSW({ type: 'CLEAR_ALL_API_CACHE' });
    },
  }; */
}
